<mat-select
  [value]="value"
  (selectionChange)="onSelectionChange($event.value)"
  panelClass="select-search-panel"
>
  <mat-option class="select-search-input">
    <input
      type="text"
      [placeholder]="placeholder"
      [(ngModel)]="searchTerm"
      (keyup)="filter(searchTerm)"
      (keydown.space)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (click)="$event.stopPropagation()"
      name="searchInput"
    />
  </mat-option>
  @for (option of filteredOptions; track option) {
    <mat-option
      [value]="option[optionValueKey]"
      matTooltip="{{ getDisplayValue(option) }}"
      matTooltipPosition="right"
      matTooltipShowDelay="500"
    >
      {{ getDisplayValue(option) }}
    </mat-option>
  }
</mat-select>
